(function () {
    'use strict';

    a3_pilot_reports.directive('basicFooter', basicFooter);

    /**
     * @memberof PilotReports
     * @ngdoc directive
     * @name basicFooter
     * @restrict E
     * @description
     *   Implementation of basicFooter (appears in groundDuty-info view)
     *
     *   Initialize a basic Footer Template and its Navigation Functionality
     *   Used in groundDuty and crewRoute view
     * @example
     *   Usage:
     *   <basic-footer></bacic-footer>
     * @ngInject
     */
    function basicFooter($location, SettingsMain, UserFactory, DataCleanerFactory) {
        /**
         * Initialize basicFooter and events
         * @memberof basicFooter
         * @param {service} scope the scope of this element
         * @param {service} element element that this direcive is assigned to
         * @param {service} attrs attribute of this element
         */
        function link(scope, element, attrs) {
            if (scope.groundDuty || scope.crewRoute) {
                var state = scope.state;
                var user = UserFactory.getUser();
                var delay = 60000;

                /**
                 * Open a modal from which u can Logout from the application
                 * @memberof groundFooter  
                 */
                function logout() {
                    var isSecure = UserFactory.isSecure()
                    bootbox.dialog({
                        message: (isSecure ?
                                "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" :
                                "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") +
                            "Please confirm that you wish to log out.",
                        title: "<strong>User Logout<strong>",
                        buttons: {
                            cancel: {
                                label: "Cancel",
                                className: "btn-default",
                                callback: function () {}
                            },
                            logout: {
                                label: "Logout",
                                className: "btn-warning",
                                callback: function () {
                                    UserFactory.clearActiveUser();
                                    if (isSecure) DataCleanerFactory.deleteAllData();

                                    UserFactory.azSignOut();

                                    location.reload(true);
                                    // need to reload, in order for the
                                    // browser to check the cache.manifest
                                    // and discover any changes
                                }
                            }
                        }
                    });
                }

                /**
                 * Navigate to Calendar View
                 * @memberof groundFooter  
                 */
                function gotoCalendar() {
                    // handleIfReport(state, flightId, report);

                    SettingsMain.setEditingPage(null);
                    // go to dashboard
                    $location.path("/");
                }
                /**
                 * Navigate to Bucket Calendar View
                 * @memberof groundFooter  
                 */
                function gotoBucketCalendar() {
                    SettingsMain.setEditingPage(null);
                    $location.path('/bucket');
                }
                /**
                 * Navigate to FAQs View
                 * @memberof groundFooter  
                 */
                function gotoFAQs() {
                    SettingsMain.setEditingPage(null);
                    $location.path('/faqs');
                }
                /**
			    * Navigate to Roster Requests View
			    * @memberof mainFooter  
			    */
                function gotoRequests() {
                    SettingsMain.setEditingPage(null);
				    $location.path("/rosterRequests");
			    }
                /**
                 * Navigate to Messages View
                 * @memberof groundFooter  
                 */
                function gotoMessageLibrary() {
                    $location.path('/messages');
                }

                scope.gotoMessageLibrary = gotoMessageLibrary;
                scope.gotoFAQs = gotoFAQs;
                scope.gotoRequests = gotoRequests;
                scope.gotoBucketCalendar = gotoBucketCalendar;
                scope.gotoCalendar = gotoCalendar;
                scope.logout = logout;

            }
        }


        return {
            restrict: 'E',
            terminal: true,
            templateUrl: "views/Main/basic-footer.tpl.html",
            scope: false,
            link: link
        }

    }

})();
